import { teladocApi, authToken } from '@td/api';
import _ from 'lodash';
import { CCMClientSettingsConfig } from '../config/CCMClientSettingsConfig';

const { BASE_URL } = CCMClientSettingsConfig;
const DEFAULT_STATE_CODE = 0;
const ERROR_EXTENSION = `If you continue seeing this message please get in touch with IT support at conconfig@teladoc.com.`;
const isSuccess = res => _.get(res, 'status', 500) === 200 || _.get(res, 'status', 500) === 304;

export const CCMClientSettingsService = {
  importFromSalesForce: async searchText => {
    try {
      const url = `${BASE_URL}/${searchText}/sf_lookup`;
      const res = await teladocApi.get(url, {}, authToken.get());

      if (isSuccess(res)) {
        if (_.isUndefined(_.get(res, 'data.contract.upstream_contract', undefined))) {
          return {
            errorMessage: `${_.get(
              res,
              'error',
              "We can't import this client code because there is no CO and PO attached"
            )} \n${ERROR_EXTENSION}`
          };
        }

        return _.get(res, 'data', { contract: null, errorMessage: null });
      }
    } catch (ex) {
      return { errorMessage: `Exception occured while importing. \n${ex} \n${ERROR_EXTENSION}` };
    }
  },

  searchClientCode: async searchText => {
    try {
      const url = `${BASE_URL}/${searchText}/status_check`;
      const res = await teladocApi.get(url, {}, authToken.get());

      if (_.get(res, 'status', null)) {
        return _.get(res, 'data', {
          status: DEFAULT_STATE_CODE,
          contract: null,
          errorMessage: null
        });
      } else {
        return { errorMessage: `${_.get(res, 'error', 'Unable to complete the search')} \n${ERROR_EXTENSION}` };
      }
    } catch (ex) {
      return { errorMessage: `Exception occured while searching. \n${ex} \n${ERROR_EXTENSION}` };
    }
  },

  submitContract: async clientId => {
    try {
      const url = `${BASE_URL}/submit_contract`;
      const res = await teladocApi.post(
        url,
        {
          client_id: clientId
        },
        authToken.get()
      );

      if (_.get(res, 'status', null)) {
        return res;
      } else {
        return { errorMessage: `${_.get(res, 'error', 'Unable to complete the search')} \n${ERROR_EXTENSION}` };
      }
    } catch (ex) {
      return { errorMessage: `Exception occured while searching. \n${ex} \n${ERROR_EXTENSION}` };
    }
  },

  syncContract: async clientId => {
    try {
      const url = `${BASE_URL}/sync_contract`;
      const res = await teladocApi.put(
        url,
        {
          client_id: clientId
        },
        authToken.get()
      );

      if (_.get(res, 'status', null)) {
        return res;
      } else {
        return { errorMessage: `${_.get(res, 'error', 'Unable to sync')} \n${ERROR_EXTENSION}` };
      }
    } catch (ex) {
      return { errorMessage: `Exception occured while syncing. \n${ex} \n${ERROR_EXTENSION}` };
    }
  },

  getContractDetails: async ({ clientId, flowDirection = 'upstream' }) => {
    try {
      const url = `${BASE_URL}/${clientId}/details/${flowDirection}`;
      const res = await teladocApi.get(url, {}, authToken.get());

      if (isSuccess(res)) {
        return res;
      } else {
        return { errorMessage: `${_.get(res, 'error', 'Unable to getContractDetails')} \n${ERROR_EXTENSION}` };
      }
    } catch (ex) {
      return { errorMessage: `Exception occured while getting contract details. \n${ex} \n${ERROR_EXTENSION}` };
    }
  },

  updateValidationMessages: async (clientId, syncStatus) => {
    try {
      const url = `${BASE_URL}/update_contract_validation_messages`;
      const res = await teladocApi.put(
        url,
        {
          client_id: clientId,
          sync_status: syncStatus
        },
        authToken.get()
      );

      if (_.get(res, 'status', null)) {
        return res;
      } else {
        return { errorMessage: `${_.get(res, 'error', 'Unable to update contract')} \n${ERROR_EXTENSION}` };
      }
    } catch (ex) {
      return { errorMessage: `Exception occured while updating. \n${ex} \n${ERROR_EXTENSION}` };
    }
  }
};
